import {
  RecapTranscriptItem,
  RecapTranscriptsProps,
} from "@/interfaces/IRecap";
import { formatTime } from "@/middleware/Date";
import { Person } from "@nexus/shared-ui";
import { Flex, List, Typography } from "antd";

const { Text } = Typography;

const Transcripts: React.FC<RecapTranscriptsProps> = ({ transcripts }) => {
  if (!transcripts?.data?.length) {
    return null;
  }

  return (
    <List
      itemLayout="vertical"
      split={false}
      dataSource={transcripts?.data}
      renderItem={(item: RecapTranscriptItem) => {
        const fullname = item?.fullName ?? "";

        return (
          <List.Item key={`${item?.speakerJId}-${item?.start}`}>
            <Flex vertical flex={1} gap={8}>
              <Flex align="center" gap={8} justify="space-between" wrap="wrap">
                <Flex align="center">
                  <Person
                    thumbUrl={
                      `${(
                        window._env_?.VITE_BASE_API_URL ||
                        import.meta.env.VITE_BASE_API_URL
                      ).replace(
                        "/meet/",
                        "/admincenter/"
                      )}/v1/users/${item?.speakerJId}/image` || ""
                    }
                  />
                  <Text className="font-weight-600">
                    {fullname || "Unknown"}
                  </Text>
                </Flex>

                <Text className="h7 color-primary">
                  {formatTime(item?.start)}
                </Text>
              </Flex>

              <Text className="text-justify">{item?.text}</Text>
            </Flex>
          </List.Item>
        );
      }}
    />
  );
};

export default Transcripts;
